import { render, staticRenderFns } from "./06b_Mauerwerk.vue?vue&type=template&id=2ce23e64&"
import script from "./06b_Mauerwerk.vue?vue&type=script&lang=js&"
export * from "./06b_Mauerwerk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports